// src/app/features/dashboard/MeetingButton.tsx
import { CalendarIcon } from 'assets/icons';
import { useAuth } from 'utils/AuthProvider';
import { useExternalLink } from 'app/providers/ExternalLinkProvider';
import './MeetingButton.css';

const MeetingButton = () => {
  const { isAdmin } = useAuth();
  const { openExternal } = useExternalLink();

  if (isAdmin) return null;

  return (
    <div className="tooltip-wrapper">
      <div
        className="relative w-8 h-8 mr-2 rounded-full flex items-center justify-center cursor-pointer shadow button-wrapper"
        onClick={() =>
          openExternal(
            'https://app.acuityscheduling.com/schedule.php?owner=14032819',
          )
        }
      >
        <CalendarIcon className="w-6 h-6 text-green" />
      </div>
      <span className="tooltip-text">Schedule a meeting with a specialist</span>
    </div>
  );
};

export default MeetingButton;
